// components/Toast.js
import React, { useEffect, useState } from 'react';
import './Toast.css';

export default function Toast({ message, duration = 2000, onClose }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!visible) return null;

  return (
    <div className="custom-toast">
      {message}
    </div>
  );
}
